import { Checkbox, FormControlLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useCallback, useState } from "react";
import MetarTaf from "../layers/MetarTaf";
import { weatherTimeWithID, WX_ID_METARTAF } from "../../../store/WeatherContentsState";
import { useRecoilValue } from "recoil";

const useStyles = makeStyles(_ => ({
  box: {
    display: 'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
  },
  item: {
    position: 'relative',
    lineHeight: '30px',
    height: '30px',
    paddingLeft: '10px'
  },
  checkLabel: {
    fontSize:"12px"
  }
}));

function LegendMetarTaf({contents: metarTaf}) {
  const classes = useStyles();
  const [contentsState, setContentsState] = useState(metarTaf.getContentsVisibleState());
  const timeInfo = useRecoilValue(weatherTimeWithID(WX_ID_METARTAF)).baseTime;
  const times = [].concat(timeInfo);

  const toggleContents = useCallback(event => {
    metarTaf.setVisible(event.target.checked, event.target.name);
    setContentsState({...contentsState, [event.target.name]:event.target.checked});
  }, [metarTaf, contentsState]);

  return (
    <div>
      {times.map((time, idx)=> {
        return(
          <div key={idx} className="legend-contents-time">
            {time}
          </div>
        )
      })}
      <ul className={classes.box}>
        <li className={classes.item}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[MetarTaf.METAR_NAME]} onChange={toggleContents} name={MetarTaf.METAR_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>METAR</span>}
          />
        </li>
        <li className={classes.item}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[MetarTaf.TAF_NAME]} onChange={toggleContents} name={MetarTaf.TAF_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>TAF</span>}
          />
        </li>
      </ul>
    </div>
  )
}

export default LegendMetarTaf;